import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { ReviewTextTranslateModel } from 'models/common/review-types';

import { UitkLink } from 'uitk-react-link';

import { ReviewTranslateLabel } from './review-translate-label';
import { ReviewTranslationText } from './review-translation-text';

const LinkTracked = ClickTracker(UitkLink);

export class ReviewTranslate extends React.Component<ReviewTextTranslateModel> {
  private showTranslateLink: boolean;
  public constructor(props) {
    super(props);
    this.toShowTranslateLink = this.toShowTranslateLink.bind(this);
    this.showTranslateLink = this.toShowTranslateLink(this.props.siteLocale, this.props.reviewLocale);
  }

  public toShowTranslateLink(siteLocale, reviewLocale) {
    return this.getLanguageCode(siteLocale).toLowerCase() !== this.getLanguageCode(reviewLocale).toLowerCase();
  }

  public getLanguageCode(locale = 'en_US') {
    return locale.indexOf('_') !== -1 ? locale.split('_')[0] : locale.split('-')[0];
  }

  public render() {
    const { translateReview, reviewTranslationState } = this.props;
    if (this.showTranslateLink) {
      if (reviewTranslationState === 'loading') {
        return (
          <div className="uitk-type-200 pwa-theme--grey-700 all-b-margin-two">
            <ReviewTranslationText reviewTranslationState={reviewTranslationState} />
          </div>
        );
      } else {
        return (
          <div className="review-translate-link all-b-margin-two">
            <ReviewTranslateLabel reviewTranslationState={reviewTranslationState} />
            <LinkTracked inline={true} linkName="Google translated review" rfrr="Reviews.GoogleTranslate">
              <a className="uitk-cell uitk-link-layout-default all-l-padding-four" target="_blank" onClick={translateReview} rel="noopener">
                <span className="uitk-type-200">
                  <ReviewTranslationText reviewTranslationState={reviewTranslationState} />
                </span>
              </a>
            </LinkTracked>
          </div>
        );
      }
    }

    return null;
  }
}
